import { Box, Flex, Icon, Button } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { NotificationCard } from '../../components/Card';
import { decode } from 'js-base64';
import { NotificationTime } from '../../components/Time';
import { useHistory } from 'react-router-dom';
import { CalendarClose } from '@kula-ai/icons-core';

interface NotificationData {
  actions: string;
  archived_at: string | null;
  category: string;
  content: string;
  created_at: string;
  custom_attributes: string;
  id: string;
  meta: any | null;
  notification_type: number;
  read_at: string | null;
  recipient: number;
  recipient_receiver: string;
  seen_at: string | null;
  sent_at: string | null;
  title: string;
  topic: string;
  type: number;
  updated_at: string;
  user_id: string;
}

interface DecodedCustomAttributes {
  provider: string;
  account_id: number;
  event_time: string;
  shared_calendar_name: string;
  shared_calendar_provider: string;
  scheduling_preferences_page_link: string;
}

interface NotificationWrapper {
  notification: NotificationData;
  components: {
    OfferApprovalView: () => void;
  };
  setMarkAll: () => void;
  onClose: () => void;
}

export const SharedCalendarNotificationWrapper = (
  notification: NotificationWrapper = {} as NotificationWrapper
) => {
  const { custom_attributes } = notification?.notification || {};
  const history = useHistory();

  // Add null check before decoding
  let data: DecodedCustomAttributes | null = null;
  if (custom_attributes) {
    try {
      data = JSON.parse(decode(custom_attributes)) as DecodedCustomAttributes;
    } catch (error) {
      console.error('Error decoding custom_attributes:', error);
    }
  }

  const {
    shared_calendar_name = '',
    shared_calendar_provider = '',
    scheduling_preferences_page_link = '',
  } = data || {};

  return (
    <NotificationCard notification={notification}>
      <Flex alignItems="start" gap="14px">
        <Box
          px="12px"
          bg="pastel-1-light"
          borderRadius="8px"
          pt="8px"
          pb="10px"
        >
          <Icon
            as={CalendarClose as any}
            color="pastel-1-dark"
            w="16px"
            h="16px"
          />
        </Box>
        <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
          <KText>
            {shared_calendar_name} calendar has been deleted in{' '}
            {shared_calendar_provider}. New interviews cannot be scheduled on
            this calendar.
          </KText>
          <NotificationTime notification={notification?.notification} />
          <Button
            w="fit-content"
            variant="primary"
            onClick={() => {
              const url = new URL(scheduling_preferences_page_link);
              history.push(url.pathname);
            }}
          >
            Go to scheduling preferences
          </Button>
        </Flex>
      </Flex>
    </NotificationCard>
  );
};
